"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontFamilies = void 0;
exports.fontFamilies = {
    robotoMono: '"Roboto Mono", Monaco, "Courier New", monospace',
    roboto: 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
    sansSerif: 'Inter, Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
    mono: '"IBM Plex Mono", "Roboto Mono", Monaco, "Courier New", monospace',
};
//# sourceMappingURL=fontFamilies.js.map